import { ListGroup, ListGroupItem } from 'react-bootstrap';

import Text from '../generic/Text';

type CliLicenseScannedMatchesProps = {
  licenseMatchJson: string;
};

type CliLicenseScannedLicenseMatch = {
  licenseId: string;
  matchString: string;
  startLine: number;
  endLine: number;
};

const parseLicenseMatches = (licenseMatchJson: string): CliLicenseScannedLicenseMatch[] | null => {
  try {
    return JSON.parse(licenseMatchJson)
      .sort((a: CliLicenseScannedLicenseMatch, b: CliLicenseScannedLicenseMatch) => a.startLine - b.startLine);
  } catch {
    return null;
  }
};

// Example licenseMatch: {"licenseId":"MIT","matchString":"MIT license","startLine":22,"endLine":22}
const LicenseGroupMatch = ({ licenseMatch }: { licenseMatch: CliLicenseScannedLicenseMatch }) => {
  const lineExplanation = licenseMatch.startLine === licenseMatch.endLine ?
    `line ${licenseMatch.startLine}`
    :
    `lines ${licenseMatch.startLine} - ${licenseMatch.endLine}`;

  return (
    <ListGroupItem>
      <p>Match to {licenseMatch.licenseId} License found on {lineExplanation}</p>
      <pre>{licenseMatch.matchString}</pre>
    </ListGroupItem>
  );
};

const CliLicenseScannedMatches = ({
  licenseMatchJson,
}: CliLicenseScannedMatchesProps) => {
  const matches = parseLicenseMatches(licenseMatchJson);
  if (matches === null) {
    return (
      <div className="padded padded-small">
        <Text.Paragraph>
          An error occurred while displaying this file. Please reload the page and try again in a few minutes.
        </Text.Paragraph>
      </div>
    );
  }

  return (
    <ListGroup style={{ overflow: 'scroll', height: 'auto', maxHeight: '100%' }}>
      {matches.map(licenseMatch => (
        <LicenseGroupMatch
          key={`${licenseMatch.licenseId}:${licenseMatch.startLine}-${licenseMatch.endLine}:${licenseMatch.matchString}`}
          licenseMatch={licenseMatch}
        />
      ))}
    </ListGroup>
  );
};

export default CliLicenseScannedMatches;
